function invokeLogin() {
    var chrome = 100;
    var width = 960;
    var height = 600;
    var left = (screen.width - width) / 2;
    var top = (screen.height - height - chrome) / 2;
    var options = "status=0,toolbar=0,location=1,resizable=1,scrollbars=1,left=" + left + ",top=" + top + ",width=" + width + ",height=" + height;
    window.open("about:blank", "login-popup", options);
}

function loginCallback(success, returnUrl) {
    if (returnUrl) {
        if (window.location.hash == '#_=_') {
            window.location.hash = '';
        }
        window.location.href = returnUrl;
    } else {
        window.location.reload();
    }
}